import script from "./message-container.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-container.vue?vue&type=script&setup=true&lang=ts"

import "./message-container.vue?vue&type=style&index=0&id=d90f4db4&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d90f4db4"]])

export default __exports__